import React, { useEffect, useState } from 'react';
import { canUseDOM, get, getPageThemeColors } from '../../utils';
import NewsCarouselGlobal from './components/global/NewsCarouselGlobal';
import NewsCarouselDet from './components/det/NewsCarouselDet';
import { hexToRgb } from '../../utils/hexToRgb';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
export const NewsCarousel = _ref => {
  let {
    fields,
    params,
    route
  } = _ref;
  const [isVdsite, setIsVdsite] = useState(true);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA';
  const variantDefault = get(params, 'variant') === 'Default';
  const sitecoreContext = useSitecoreContext();
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const variables = {
    '--newCarousel-color-with-opacity': hexToRgb(selectedPrimaryColor).concat(", 0.1")
  };
  return /*#__PURE__*/React.createElement("div", {
    style: variables
  }, isDetSite && variantDefault ? /*#__PURE__*/React.createElement(NewsCarouselDet, {
    params: params,
    route: route,
    fields: fields
  }) : /*#__PURE__*/React.createElement(NewsCarouselGlobal, {
    params: params,
    route: route,
    fields: fields
  }));
};
export default NewsCarousel;